<template>
  <div id="app">
    <nav :class="['navbar navbar-expand-lg', nauchete ? 'navbar-light registry-nav' : 'navbar-dark bg-primary']">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <strong v-if="nauchete" class="registry-brand">НА УЧЕТЕ.РФ</strong>
          <strong v-else>QR Data</strong>
        </router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <router-link class="nav-link" to="/">Главная</router-link>
            </li>
            <li class="nav-item" v-if="isAdmin">
              <router-link class="nav-link" to="/generate">Генерация паспортов</router-link>
            </li>
            <li class="nav-item" v-if="isAdmin">
              <router-link class="nav-link" to="/batches">Партии</router-link>
            </li>
            <li class="nav-item" v-if="isAdmin">
              <router-link class="nav-link" to="/admin">Администрирование</router-link>
            </li>
            <li class="nav-item" v-if="!isAdmin">
              <a class="nav-link" href="#" @click.prevent="requestAdminAccess">Вход</a>
            </li>
            <li class="nav-item" v-if="isAdmin">
              <a class="nav-link" href="#" @click.prevent="logout">Выход</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <main :class="nauchete && $route.name === 'Home' ? '' : 'container mt-4'">
      <router-view />
    </main>

    <footer :class="nauchete ? 'registry-footer' : 'bg-light mt-5 py-4'">
      <div class="container text-center">
        <p v-if="nauchete" class="mb-0">© {{ currentYear }} «На учёте» · Цифровые паспорта оборудования</p>
        <p v-else class="text-muted mb-0">© {{ currentYear }} QR Data — Система учета паспортов газовых баллонов</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { isAdmin, login, verifyStoredPassword } from './auth'
import { isNaucheteHost } from './qrDomains'

export default {
  name: 'App',
  data() {
    return {
      isAdmin: false,
      nauchete: isNaucheteHost(),
      currentYear: new Date().getFullYear()
    }
  },
  async mounted() {
    document.title = this.nauchete ? 'На учёте — цифровые паспорта оборудования' : 'QR Data — паспорта газовых баллонов'
    this.isAdmin = isAdmin()
    this.isAdmin = await verifyStoredPassword()
  },
  methods: {
    async requestAdminAccess() {
      if (await login()) {
        this.isAdmin = true
        this.$router.push('/admin')
      }
    },
    logout() {
      localStorage.removeItem('adminAuth')
      this.isAdmin = false
      if (this.$route.path === '/admin') {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

.passport-card {
  transition: transform 0.2s;
}

.passport-card:hover {
  transform: translateY(-2px);
}

.btn-primary {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.btn-primary:hover {
  background-color: #0b5ed7;
  border-color: #0a58ca;
}

/* Плейсхолдеры — светло-серые и курсивные, чтобы не путать с реальными значениями */
.form-control::placeholder,
.form-select::placeholder,
input::placeholder,
textarea::placeholder {
  color: #b9bec4 !important;
  opacity: 1; /* Firefox по умолчанию приглушает opacity */
  font-style: italic;
}

.registry-nav {
  min-height: 82px;
  padding: 0;
  background: #fff;
  border-bottom: 1px solid #dbe9ef;
  box-shadow: 0 3px 14px rgba(26, 71, 94, .05);
}

.registry-nav > .container {
  min-height: 82px;
  align-items: center;
}

.registry-nav .navbar-brand {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

.registry-brand {
  color: #2799b1;
  font-size: 21px;
  font-weight: 800;
  letter-spacing: .075em;
}

.registry-nav .navbar-nav { align-items: center; }
.registry-nav .nav-link {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding-top: 0;
  padding-bottom: 0;
  color: #4c6a7d;
}
.registry-nav .nav-link:hover { color: #168ba4; }

@media (max-width: 991.98px) {
  .registry-nav,
  .registry-nav > .container {
    min-height: 68px;
  }

  .registry-nav .navbar-toggler {
    width: 46px;
    height: 42px;
    padding: 6px 9px;
  }

  .registry-nav .navbar-collapse {
    width: 100%;
    padding: 8px 0 14px;
  }

  .registry-nav .navbar-nav { align-items: stretch; }
  .registry-nav .nav-link { min-height: 40px; }
}

.registry-footer {
  padding: 28px 0;
  background: #153550;
  color: #c3d6df;
  font-size: 13px;
}
</style>
